import React from 'react';
import { FormSectionTitle } from '../../../Components/Typography/Headlines';
import { makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import CustomButton from '../../../Components/Buttons/CustomButton';
import { ROOT_DOMAIN } from '../../../constants';
import { useQuery } from 'react-admin';
import { get, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

export const FIRM_CLAIMED = 'Claimed';
export const FIRM_UNCLAIMED = 'Unclaimed';
export const FIRM_INACTIVE = 'Inactive';
const HOW_TO_CLAIM_LIST = [
    {
        id: 1,
        name: 'Make changes to your public firm profile',
    },
    {
        id: 2,
        name: 'Access our management profile',
    },
    {
        id: 3,
        name: 'Learn more about what we can do to help your firm',
    },
];


const useStyles = makeStyles((theme) => ({
    claimButton: {
        backgroundColor: theme.palette.error.main,
        color: 'white',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    listContainer: {
        marginLeft: '-1rem',
    },
}));


export function ListSection() {
    const firmId = useSelector(({basicInfo}) => get(basicInfo, 'firm_id'))
    const firmVisibility = useSelector(({basicInfo}) => get(basicInfo, 'firm_visibility'))
    const firmUrl = useSelector(({basicInfo}) => get(basicInfo, 'firm_url'))

    if (!firmId) {
        return null;
    }

    if (firmVisibility === FIRM_INACTIVE) {
        return null;
    }

    if (firmVisibility === FIRM_CLAIMED) {
        return null;
    }
    return <ClaimFirm firmUrl={firmUrl}/>;
};

const ClaimFirm = ({ firmUrl }) => {
    const classes = useStyles();

    if (!firmUrl) {
        return null;
    }

    return (
        <>
            <FormSectionTitle title={'Claim Your Free Firm Profile'}/>
            <Grid container direction={'row'} alignItems={'center'} spacing={2}>
                <Grid item className={classes.listContainer} sm={6}>
                    <ShowList values={HOW_TO_CLAIM_LIST}/>
                </Grid>
                <Grid item className={classes.buttonContainer} sm={6}>
                    <CustomButton
                        size={'large'}
                        variant={'contained'}
                        href={`${ROOT_DOMAIN}/${firmUrl}`}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                        className={classes.claimButton}
                    >
                        Claim firm
                    </CustomButton>
                </Grid>
            </Grid>
        </>

    );
};

const ShowList = ({ values, showAdmins = false }) => {
    if (isEmpty(values)) {
        return null;
    }

    return (
        <ul>
            {
                values.map((value) => (
                    <li key={'firm-tab-list:' + value.id}>
                        {showAdmins ?
                            <Typography>{value.firstName}&nbsp;{value.lastName}</Typography>
                            : <Typography>{value.name}</Typography>
                        }
                    </li>
                ))
            }
        </ul>
    );
};
